export default __webpack_public_path__ + "static/media/About-Super-Player-Auction.0a8d76f0.png";